import React, { useEffect } from 'react';
import {
  Divider,
  Card,
  CardContent,
  CardHeader,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Title from './Title';
import { fetchSites } from '../../actions';

const SiteStatus = () => {
  const dispatch = useDispatch();

  const { sites } = useSelector((state) => state.dashboard);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchSites());
    }
  }, [dispatch, user]);

  const title = '작업자별 현황';
  const unitDesc = '(단위: 명)';

  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader title={<Title title={title} unitDesc={unitDesc} />} />
      <Divider />
      <CardContent>
        <TableContainer>
          <Table sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
            <TableBody>
              {sites.map((site) => (
                <TableRow key={site.devEUI} sx={{}}>
                  <TableCell sx={{ backgroundColor: '#eeeeee', width: '50%' }}>
                    {site.description}
                  </TableCell>
                  <TableCell>{site.n_attendances}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default SiteStatus;
